import {
  CREATE_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
  CREATE_VEHICLE_LOCATION_LOGS,
  GET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
  GET_VEHICLE_LIST,
  GET_VEHICLE_LOCATION_LOGS,
  RESET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING,
  RESET_VEHICLE_LOCATION_LOGS,
  GET_TENANT_LOGO_URL,
} from 'src/redux/Actions/Type';

const initialState = {
  vehicleList: [],
  vehicleLocationLogs: {
    locations: [],
    vehicleTracking: {
      color_theme: 'blueTheme',
      tenant_name: 'Vehicle Tracking',
      vehicle_number: '-/-',
      capacity: 0,
    },
  },
  createVehicleLocationLogs: {},
  createPODAttachmentsForVehicleTracking: {},
  getTenantLogo: {},
  podAttachmentsForVehicleTracking: {
    attachments: [],
  },
};

export default function VehicleReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case GET_VEHICLE_LIST:
      return {
        ...state,
        vehicleList: payload,
      };
    case GET_VEHICLE_LOCATION_LOGS:
      return {
        ...state,
        vehicleLocationLogs: payload,
      };
    case CREATE_VEHICLE_LOCATION_LOGS:
      return {
        ...state,
        createVehicleLocationLogs: payload,
      };
    case CREATE_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        createPODAttachmentsForVehicleTracking: payload,
      };
    case GET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        podAttachmentsForVehicleTracking: payload,
      };
    case RESET_VEHICLE_LOCATION_LOGS:
      return {
        ...state,
        vehicleLocationLogs: initialState.vehicleLocationLogs,
        createVehicleLocationLogs: {},
      };
    case RESET_POD_ATTACHMENTS_FOR_VEHICLE_TRACKING:
      return {
        ...state,
        createPODAttachmentsForVehicleTracking: {},
        podAttachmentsForVehicleTracking:
          initialState.podAttachmentsForVehicleTracking,
      };
    case GET_TENANT_LOGO_URL:
      return {
        ...state,
        getTenantLogo: payload,
      };
    default:
      return state;
  }
}
